import { render, staticRenderFns } from "./ClubItem.vue?vue&type=template&id=4431c570&"
import script from "./ClubItem.vue?vue&type=script&lang=js&"
export * from "./ClubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports